import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import DoctorsFunnel from "@/pages/DoctorsFunnel";
import CliniciansFunnel from "@/pages/CliniciansFunnel";
import PatientsFunnel from "@/pages/PatientsFunnel";
import LeadsFunnel from "@/pages/LeadsFunnel";
import Reports from "@/pages/Reports";
import UsersMaster from "@/pages/UsersMaster";
import CalendarPage from "@/pages/CalendarPage";
import Receipt from "@/pages/Receipt";

const ProtectedBare = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
};

// Landing for visitors; Dashboard (in Layout) once authenticated
const Root = () => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Landing />;
  return <Layout><Dashboard /></Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/" element={<Root />} />
            <Route path="/leads" element={<Protected><LeadsFunnel /></Protected>} />
            <Route path="/doctors" element={<Protected><DoctorsFunnel /></Protected>} />
            <Route path="/clinicians" element={<Protected><CliniciansFunnel /></Protected>} />
            <Route path="/patients" element={<Protected><PatientsFunnel /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
            <Route path="/users" element={<Protected><UsersMaster /></Protected>} />
            <Route path="/receipt/:id" element={<ProtectedBare><Receipt /></ProtectedBare>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
